export class CookieManager {
    constructor(cookieDays = 7) {
        this.cookieDays = cookieDays;
    }

    set(key, value) {
        const expires = new Date(Date.now() + this.cookieDays * 24 * 60 * 60 * 1000).toUTCString();
        const domainPart = this.getDomainForDe();
        let type = typeof value;
        if (value === null) type = 'null';

        const payload = {
            __t: type,
            __v: value,
        };

        const storedValue = encodeURIComponent(JSON.stringify(payload));

        const cookieString = [
            `${encodeURIComponent(key)}=${storedValue}`,
            `Expires=${expires}`,
            `SameSite=Lax`,
            `Path=/`,
            domainPart,
        ]
            .filter(Boolean)
            .join('; ');

        document.cookie = cookieString;
    }

    get(key) {
        const target = encodeURIComponent(key) + '=';
        for (const item of document.cookie.split('; ')) {
            if (item.startsWith(target)) {
                const raw = decodeURIComponent(item.slice(target.length));

                try {
                    const parsed = JSON.parse(raw);
                    if (!parsed) return null;
                    return parsed.__v || parsed;
                } catch {
                    // Fall through to return raw
                }
                return raw;
            }
        }
        return null;
    }

    remove(key) {
        const rootDomain = this.getDomainForDe();
        const expires = `Expires=${new Date(0).toUTCString()}; SameSite=Lax; Path=/; ${rootDomain}`;
        document.cookie = `${encodeURIComponent(key)}=; ${expires}`;
    }

    getDomainForDe() {
        const { hostname } = window.location;
        const parts = hostname.split('.');
        if (parts.length > 2) return `Domain=.${parts.slice(-2).join('.')}`;
        return '';
    }
}
